import { CountryCodes } from '../constants/CountryCodes';

export const getQueryVariables = query => {
  const vars = query.split('&');
  const queryParams = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const variable = decodeURIComponent(pair[0]);
    queryParams[variable] = decodeURIComponent(pair[1]);
  }
  return queryParams;
};

export const getQueryParamFromURL = url => {
  const queryString = url && url.split('?')[1] ? url.split('?')[1] : '';
  return getQueryVariables(queryString);
}

export const getQueryParams = url => {
  const query = getQueryParamFromURL(url)
  if (query.hasOwnProperty('')) {
    return {}
  } else {
    return query
  }
}

export const getCookieValue = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const getIndexFromCountryName = countryId => {
  for (let i = 0; i < CountryCodes.length; ++i) {
    if (CountryCodes[i].countryId === countryId) return CountryCodes[i].value;
  }
  return 0;
};